import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import { TrainingAndTestingModel } from "@tFissco/ApiModels";
import {
    submitTrainingAndTesting as submitTrainingAndTestingApi,
    TrainingAndTestingApiParameter,
} from "@tFissco/Services/TrainingAndTestingService";

type TrainingAndTestingParameter = {
    topic: string | undefined;
    firstName: string;
    lastName: string;
    company: string;
    phoneNumber: string;
    emailAddress: string;
    locationAndDate: string;
    onSuccess?: () => void;
    onError?: (error: string, statusCode?: number) => void;
} & HasOnSuccess;

type HandlerType = ApiHandlerDiscreteParameter<
    TrainingAndTestingParameter,
    TrainingAndTestingApiParameter,
    ServiceResult<TrainingAndTestingModel>
>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        trainingAndTestingModel: {
            ...props.parameter,
        } as TrainingAndTestingModel,
    };
};

export const SendDataToApi: HandlerType = async props => {
    await submitTrainingAndTestingApi(props.apiParameter);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.();
};

export const chain = [PopulateApiParameter, SendDataToApi, ExecuteOnSuccessCallback];

const submitTrainingAndTesting = createHandlerChainRunner(chain, "SubmitTrainingAndTesting");
export default submitTrainingAndTesting;
